module.exports = __webpack_public_path__ + "img/toilet-paper-blank.7b04e472.svg";